import React from "react";
import FormSection from "../../atoms/form-section/FormSection.jsx";

const FieldSection = ({ title, children }) => (
  <FormSection title={title}>{children}</FormSection>
);

export default FieldSection;
